var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.speaker)?_c('speaker',{attrs:{"speaker-config":_vm.speakerConfig,"speaker":_vm.speaker}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }